import Footer from "../../../Components/Footer/Footer"

export const OutstationPolicy=()=>{
    return(
        <div style={{backgroundColor:"rgba(0,0,0,0.865)",color:"white",padding:"40px"}}>
            <h3>Outstation Policy</h3>
          <p>You are free to drive and explore the entire nation because all AMR Wheels vehicles are authorized for self-driving and have an All India Permit. When crossing into another state, make sure to have a visitor's permit because the vehicles have a commercial license. Depending on the regulations of the individual states, these permits might be valid for a few days, weeks, or months.</p>
          <ol>
            <li> Check the Vehicle's paperwork at the RTO checkpoint.</li>
            <li>Park your car at the RTO checkpoint at the state boundary so you can clear the paperwork needed to get a visitor's permit.
</li>
            <li>For any inconvenience,contact</li>
            <p style={{marginTop:"0.5rem"}}> Support: +91 9546437276</p>
          <p> Email: ariyanmishra137@gmail.com</p>
          </ol>
          <Footer/>
        </div>
    )
}